import React from "react";
import type { EquipmentCategoryType } from "../../../utils/types";
import * as EquipmentStyles from "../styles/Equipments";
import * as Container from "../../../../../../common-deprecated/styles/v2/lexus/globals/Container";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Icons from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import EquipmentContent from "./EquipmentContent";
import { useEquipmentV2Selector } from "../../../redux/store";
import { EquipmentV2Label } from "../../../utils/labels";
import { trackCustomizeLink } from "../../../utils/tracking";
import { getBuildUrl } from "../../../utils/utils";

type SharedEquipmentProps = {
    equipmentLabels: (string | null)[];
    equipment: EquipmentCategoryType[];
};

const Equipment = (props: SharedEquipmentProps): JSX.Element => {
    const { equipmentLabels, equipment } = props;
    const commonSettings = useEquipmentV2Selector((state) => state.commonSettings);
    const selectedCar = useEquipmentV2Selector((state) => state.equipment.selectedCar);
    return (
        <Container.default mb={80} px={3}>
            <Flex.Row mx="-24px">
                <Flex.Col width={{ xs: 1, lg: 1 / 4 }} px={3}>
                    <EquipmentStyles.Title>{equipmentLabels[0]}</EquipmentStyles.Title>
                    <EquipmentStyles.CustomizeButton
                        onClick={() => trackCustomizeLink(commonSettings.component)}
                        href={getBuildUrl(selectedCar, commonSettings)}
                        rel="nofollow"
                    >
                        <Icons.IconRainbowCircle />
                        <EquipmentV2Label label="equipmentCustomize" />
                    </EquipmentStyles.CustomizeButton>
                </Flex.Col>
                <Flex.Col width={{ xs: 1, lg: 3 / 4 }} px={3} mt={{ xs: 2, lg: 0 }}>
                    <EquipmentStyles.ContentWrapper>
                        {equipmentLabels[1] && (
                            <EquipmentStyles.Description>{equipmentLabels[1]}</EquipmentStyles.Description>
                        )}
                        <EquipmentContent content={equipment} />
                    </EquipmentStyles.ContentWrapper>
                </Flex.Col>
            </Flex.Row>
        </Container.default>
    );
};

export default Equipment;
